const addressAvatarPairs = {
  "00": 1,
  "01": 2,
  "02": 3,
  "03": 4,
  "04": 5,
  "05": 6,
  "06": 7,
  "07": 8,
  "08": 9,
  "09": 10,
  "0a": 11,
  "0b": 12,
  "0c": 13,
  "0d": 14,
  "0e": 15,
  "0f": 16,
  "10": 17,
  "11": 18,
  "12": 19,
  "13": 20,
  "14": 21,
  "15": 22,
  "16": 23,
  "17": 24,
  "18": 25,
  "19": 26,
  "1a": 27,
  "1b": 28,
  "1c": 29,
  "1d": 30,
  "1e": 31,
  "1f": 32,
  "20": 33,
  "21": 34,
  "22": 35,
  "23": 36,
  "24": 37,
  "25": 38,
  "26": 39,
  "27": 40,
  "28": 41,
  "29": 42,
  "2a": 43,
  "2b": 44,
  "2c": 45,
  "2d": 46,
  "2e": 47,
  "2f": 48,
  "30": 49,
  "31": 50,
  "32": 51,
  "33": 52,
  "34": 53,
  "35": 54,
  "36": 55,
  "37": 56,
  "38": 57,
  "39": 58,
  "3a": 59,
  "3b": 60,
  "3c": 61,
  "3d": 62,
  "3e": 63,
  "3f": 64,
  "40": 1,
  "41": 2,
  "42": 3,
  "43": 4,
  "44": 5,
  "45": 6,
  "46": 7,
  "47": 8,
  "48": 9,
  "49": 10,
  "4a": 11,
  "4b": 12,
  "4c": 13,
  "4d": 14,
  "4e": 15,
  "4f": 16,
  "50": 17,
  "51": 18,
  "52": 19,
  "53": 20,
  "54": 21,
  "55": 22,
  "56": 23,
  "57": 24,
  "58": 25,
  "59": 26,
  "5a": 27,
  "5b": 28,
  "5c": 29,
  "5d": 30,
  "5e": 31,
  "5f": 32,
  "60": 33,
  "61": 34,
  "62": 35,
  "63": 36,
  "64": 37,
  "65": 38,
  "66": 39,
  "67": 40,
  "68": 41,
  "69": 42,
  "6a": 43,
  "6b": 44,
  "6c": 45,
  "6d": 46,
  "6e": 47,
  "6f": 48,
  "70": 49,
  "71": 50,
  "72": 51,
  "73": 52,
  "74": 53,
  "75": 54,
  "76": 55,
  "77": 56,
  "78": 57,
  "79": 58,
  "7a": 59,
  "7b": 60,
  "7c": 61,
  "7d": 62,
  "7e": 63,
  "7f": 64,
  "80": 1,
  "81": 2,
  "82": 3,
  "83": 4,
  "84": 5,
  "85": 6,
  "86": 7,
  "87": 8,
  "88": 9,
  "89": 10,
  "8a": 11,
  "8b": 12,
  "8c": 13,
  "8d": 14,
  "8e": 15,
  "8f": 16,
  "90": 17,
  "91": 18,
  "92": 19,
  "93": 20,
  "94": 21,
  "95": 22,
  "96": 23,
  "97": 24,
  "98": 25,
  "99": 26,
  "9a": 27,
  "9b": 28,
  "9c": 29,
  "9d": 30,
  "9e": 31,
  "9f": 32,
  a0: 33,
  a1: 34,
  a2: 35,
  a3: 36,
  a4: 37,
  a5: 38,
  a6: 39,
  a7: 40,
  a8: 41,
  a9: 42,
  aa: 43,
  ab: 44,
  ac: 45,
  ad: 46,
  ae: 47,
  af: 48,
  b0: 49,
  b1: 50,
  b2: 51,
  b3: 52,
  b4: 53,
  b5: 54,
  b6: 55,
  b7: 56,
  b8: 57,
  b9: 58,
  ba: 59,
  bb: 60,
  bc: 61,
  bd: 62,
  be: 63,
  bf: 64,
  c0: 1,
  c1: 2,
  c2: 3,
  c3: 4,
  c4: 5,
  c5: 6,
  c6: 7,
  c7: 8,
  c8: 9,
  c9: 10,
  ca: 11,
  cb: 12,
  cc: 13,
  cd: 14,
  ce: 15,
  cf: 16,
  d0: 17,
  d1: 18,
  d2: 19,
  d3: 20,
  d4: 21,
  d5: 22,
  d6: 23,
  d7: 24,
  d8: 25,
  d9: 26,
  da: 27,
  db: 28,
  dc: 29,
  dd: 30,
  de: 31,
  df: 32,
  e0: 33,
  e1: 34,
  e2: 35,
  e3: 36,
  e4: 37,
  e5: 38,
  e6: 39,
  e7: 40,
  e8: 41,
  e9: 42,
  ea: 43,
  eb: 44,
  ec: 45,
  ed: 46,
  ee: 47,
  ef: 48,
  f0: 49,
  f1: 50,
  f2: 51,
  f3: 52,
  f4: 53,
  f5: 54,
  f6: 55,
  f7: 56,
  f8: 57,
  f9: 58,
  fa: 59,
  fb: 60,
  fc: 61,
  fd: 62,
  fe: 63,
  ff: 64,
}

export default addressAvatarPairs
